export const FEEDBACK_TYPES = {
  GENERAL: 'general',
  SESSION: 'session',
  TOPIC: 'topic',
};

export const RATING_CATEGORIES = [
  { key: 'game', label: 'Game' },
  { key: 'machine', label: 'Machine' },
  { key: 'heroTrainer', label: 'Hero Trainer' },
];

export const SUBMIT_STATUS = {
  saving: 'saving',
  saved: 'saved',
};

export const IDENTITY_MODES = {
  ACCOUNT: 'account',
  USERNAME: 'username',
  ANONYMOUS: 'anonymous',
};

export const MAX_BODY_LENGTH = 5000;
export const MAX_DISPLAY_NAME_LENGTH = 100;
export const MAX_GUEST_USERNAME_LENGTH = 120;

export const FEEDBACK_ACCENT = '#ff6b00';
export const FEEDBACK_LINK = '#0076FF';
export const FEEDBACK_SUCCESS = '#7ED321';

/** Native BBVR dark form chrome (matches FormInput). */
export const FEEDBACK_FIELD_SHELL = '#191B1C';
export const FEEDBACK_FIELD_TEXT = '#F1F1F1';
export const FEEDBACK_FIELD_PLACEHOLDER = 'rgba(241, 241, 241, 0.45)';
export const FEEDBACK_FIELD_LABEL = '#F1F1F1';

export const SESSION_SUMMARY_CONTEXT_FIELDS = [
  'SessionID',
  'UserID',
  'Username',
  'StartTime',
  'startTimestamp',
  'SessionType',
  'ChalName',
  'League',
  'isRaidBattle',
];
